import { Link } from 'react-router-dom';
import "./BreadcrumbBasic.scss"

const BreadcrumbBasic = ({
    list = [],
    activeLang = 'ru',
}) => {

    const translateMain = () => {
        if (activeLang == 'eng') return 'Main'
        if (activeLang == 'tur') return 'Ana Sayfa'
        return 'Главная'
    }

    return (
        <div className='header-breadcrumb'>
            <nav className="breadcrumb__nav">
                <ul className="breadcrumb">
                    {list.map(({ label, link, func }, ind) => {

                        const last_point = list.length == ind + 1

                        return <li className="breadcrumb__link" key={label + link}>
                            {/* <img className='img-home' {...home_icon} /> */}


                            {(link && !last_point) ? <Link href='/'
                            onClick={func}
                            >{label}</Link> : label}
                        </li>
                    })}

                </ul>
            </nav>
        </div>

    )
}

export { BreadcrumbBasic } 